import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "show", "hide", "button"]
  static values = { showLabel: { type: String, default: "Show value" }, hideLabel: { type: String, default: "Hide value" } }

  toggle() {
    const hidden = this.inputTarget.type === "password"

    this.inputTarget.type = hidden ? "text" : "password"
    this.showTarget.hidden = hidden
    this.hideTarget.hidden = !hidden
    this.buttonTarget.setAttribute("aria-pressed", String(hidden))
    this.buttonTarget.setAttribute("aria-label", hidden ? this.hideLabelValue : this.showLabelValue)
  }
}
